import { BracketsCurly } from '@phosphor-icons/react';

export default BracketsCurly;
